<template>
  <div v-title data-title="安全地图">
    <div class="sms-content-top">
      <div class="content-business business-safe-result" ref="ghKpis">
        <div class="content-business-main">
          <div class="main-box">
            <div class="business-cell" v-for="safeResult in ghKpis">
              <div class="cell-left">
                <div class="event-level">
                  <div class="event-level-box" @click="toSafeResult(safeResult)">
                    <span class="risk-color" :class="safeResult.colorClass"></span>
                    <span class="risk-name">{{ safeResult.kpiName }}</span>
                    <i class="risk-detail el-icon-arrow-right"></i>
                  </div>
                </div>
                <div class="part-bottom">
                  <div class="achievement-index-left">
                    <div class="index-name"><span>目标值 :</span></div>
                    <div class="index-name"><span>实际值 :</span></div>
                  </div>
                  <div class="achievement-index-right">
                    <div class="index-value">
                      <span>{{ safeResult.target }}</span>
                    </div>
                    <div class="index-value">
                      <span>{{ safeResult.actual }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cell-right">
              </div>
            </div>
          </div>
          <div class="operate">
            <div class="el-date-picker-wrapper">
              <el-date-picker
                v-model="safeResult.dateConfig.currentDateText"
                format="yyyy-MM"
                :editable="false"
                :clearable="false"
                prefix-icon="el-icon-caret-bottom"
                type="month"
                @change="safeResult.dateConfig.onYearMonthChange"
              >
              </el-date-picker>
            </div>
          </div>
        </div>
      </div>
      <div class="content-business business-core-risk" ref="dhKpis">
        <div class="content-business-main">
          <div class="main-box">
            <div class="business-cell" v-for="safeResult in dhKpis">
              <div class="cell-left">
                <div class="event-level">
                  <div class="event-level-box" @click="toSafeResult(safeResult)">
                    <span class="risk-color" :class="safeResult.colorClass"></span>
                    <span class="risk-name">{{ safeResult.kpiName }}</span>
                    <i class="risk-detail el-icon-arrow-right"></i>
                  </div>
                </div>
                <div class="part-bottom">
                  <div class="achievement-index-left">
                    <div class="index-name"><span>目标值 :</span></div>
                    <div class="index-name"><span>实际值 :</span></div>
                  </div>
                  <div class="achievement-index-right">
                    <div class="index-value">
                      <span>{{ safeResult.target }}</span>
                    </div>
                    <div class="index-value">
                      <span>{{ safeResult.actual }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cell-right">
              </div>
            </div>
          </div>
          <div class="operate">
            <div class="el-date-picker-wrapper">
              <el-date-picker
                v-model="coreRisk.dateConfig.currentDateText"
                format="yyyy-MM"
                :editable="false"
                :clearable="false"
                prefix-icon="el-icon-caret-bottom"
                type="month"
                @change="coreRisk.dateConfig.onYearMonthChange"
              >
              </el-date-picker>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sms-content-bottom">
      <div class="content-business business-running-overview" ref="jcKpis">
        <div class="content-business-main">
          <div class="operate">
            <div class="el-date-picker-wrapper">
              <el-date-picker
                v-model="operationOverviewConfig.dateConfig.currentDateText"
                format="yyyy-MM"
                :editable="false"
                :clearable="false"
                prefix-icon="el-icon-caret-bottom"
                type="month"
                @change="operationOverviewConfig.dateConfig.onYearMonthChange"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="main-box">
            <div class="business-cell" v-for="safeResult in jcKpis">
              <div class="cell-left">
                <div class="event-level">
                  <div class="event-level-box" @click="toSafeResult(safeResult)">
                    <span class="risk-color" :class="safeResult.colorClass"></span>
                    <span class="risk-name">{{ safeResult.kpiName }}</span>
                    <i class="risk-detail el-icon-arrow-right"></i>
                  </div>
                </div>
                <div class="part-bottom">
                  <div class="achievement-index-left">
                    <div class="index-name"><span>目标值 :</span></div>
                    <div class="index-name"><span>实际值 :</span></div>
                  </div>
                  <div class="achievement-index-right">
                    <div class="index-value">
                      <span>{{ safeResult.target }}</span>
                    </div>
                    <div class="index-value">
                      <span>{{ safeResult.actual }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cell-right">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-business business-key-process" ref="aqKpis">
        <div class="content-business-main">
          <div class="operate">
            <div class="el-date-picker-wrapper">
              <el-date-picker
                v-model="keyProcess.dateConfig.currentDateText"
                format="yyyy-MM"
                :editable="false"
                :clearable="false"
                prefix-icon="el-icon-caret-bottom"
                type="month"
                @change="keyProcess.dateConfig.onYearMonthChange"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="main-box">
            <div class="business-cell" v-for="safeResult in aqKpis">
              <div class="cell-left">
                <div class="event-level">
                  <div class="event-level-box" @click="toSafeResult(safeResult)">
                    <span class="risk-color" :class="safeResult.colorClass"></span>
                    <span class="risk-name">{{ safeResult.kpiName }}</span>
                    <i class="risk-detail el-icon-arrow-right"></i>
                  </div>
                </div>
                <div class="part-bottom">
                  <div class="achievement-index-left">
                    <div class="index-name"><span>目标值 :</span></div>
                    <div class="index-name"><span>实际值 :</span></div>
                  </div>
                  <div class="achievement-index-right">
                    <div class="index-value">
                      <span>{{ safeResult.target }}</span>
                    </div>
                    <div class="index-value">
                      <span>{{ safeResult.actual }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cell-right">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sms-content-center-container">
      <div class="left">
        <div class="name">高后果类指标</div>
        <div class="name">基础类指标</div>
      </div>
      <div class="sms-content-center">
        <div class="inner">
          <div class="name">安全</div>
          <div class="name">地图</div>
        </div>
      </div>
      <div class="right">
        <div class="name">低后果类指标</div>
        <div class="name">安全管理类</div>
      </div>
    </div>
    <div class="sms-content-right-container" @click="onSafeMapClick">
      <img src="../../assets/arrow-right.png" class="light-icon" alt="">
      <img src="../../assets/arrow-right-dark.png" class="dark-icon" alt="">
    </div>
  </div>
</template>
<script>
import {getRequest, postRequest} from "../../utils/request";

export default {
  props: {
    company: String,
    year: Number
  },
  data() {
    return {
      //高后果类指标
      ghKpis: [
        {
          "kpiCode": "SR-001",
          "kpiName": "飞行事故",
          "levelColor": null,
          "target": "-",
          "actual": "-",
          "colorClass": "default-bg-color"
        }, {
          "kpiCode": "SR-002",
          "kpiName": "地面事故",
          "levelColor": null,
          "target": 1,
          "actual": "-",
          "colorClass": "default-bg-color"
        }, {
          "kpiCode": "SR-003",
          "kpiName": "维修事故",
          "levelColor": null,
          "target": 0.5,
          "actual": "-",
          "colorClass": "default-bg-color"
        }, {
          "kpiCode": "SR-005",
          "kpiName": "严重征候万时率",
          "levelColor": null,
          "target": "-",
          "actual": "-",
          "colorClass": "default-bg-color"
        }, {
          "kpiCode": "SR-006",
          "kpiName": "运输航空征候万时率",
          "levelColor": null,
          "target": 4.6,
          "actual": "-",
          "colorClass": "default-bg-color"
        }, {
          "kpiCode": "SR-007",
          "kpiName": "机械原因征候万时率",
          "levelColor": null,
          "target": "-",
          "actual": "-",
          "colorClass": "default-bg-color"
        }, {
          "kpiCode": "SR-004",
          "kpiName": "责任原因征候万时率",
          "levelColor": null,
          "target": "-",
          "actual": "-",
          "colorClass": "default-bg-color"
        }, {
          "kpiCode": "SR-009",
          "kpiName": "公司责任地面征候万架次率",
          "levelColor": null,
          "target": 1.2,
          "actual": "-",
          "colorClass": "default-bg-color"
        }, {
          "kpiCode": "SR-047",
          "kpiName": "千人负伤率",
          "levelColor": null,
          "target": 1.8,
          "actual": "-",
          "colorClass": "default-bg-color"
        }
      ],
      //低后果类指标
      dhKpis: [
        {
          "kpiCode": "SR-001",
          "kpiName": "安全一类事件万时率",
          "levelColor": null,
          "target": "-",
          "actual": "-",
          "colorClass": "default-bg-color"
        }, {
          "kpiCode": "SR-002",
          "kpiName": "二类事件万时率",
          "levelColor": null,
          "target": 1,
          "actual": "-",
          "colorClass": "default-bg-color"
        }, {
          "kpiCode": "SR-047",
          "kpiName": "不安全事件千次率",
          "levelColor": null,
          "target": 1.8,
          "actual": "-",
          "colorClass": "default-bg-color"
        }, {
          "kpiCode": "SR-005",
          "kpiName": "人为不安全事件千次率",
          "levelColor": null,
          "target": "-",
          "actual": "-",
          "colorClass": "default-bg-color"
        }, {
          "kpiCode": "SR-006",
          "kpiName": "机组原因事件千次率",
          "levelColor": null,
          "target": 4.6,
          "actual": "-",
          "colorClass": "default-bg-color"
        }, {
          "kpiCode": "SR-007",
          "kpiName": "机械原因事件千次率",
          "levelColor": null,
          "target": "-",
          "actual": "-",
          "colorClass": "default-bg-color"
        }, {
          "kpiCode": "SR-004",
          "kpiName": "外部/代理原因事件千次率",
          "levelColor": null,
          "target": "-",
          "actual": "-",
          "colorClass": "default-bg-color"
        }, {
          "kpiCode": "SR-009",
          "kpiName": "雷击事件千次率",
          "levelColor": null,
          "target": 1.2,
          "actual": "-",
          "colorClass": "default-bg-color"
        }, {
          "kpiCode": "SR-003",
          "kpiName": "安保差错事件万时率",
          "levelColor": null,
          "target": 0.5,
          "actual": "-",
          "colorClass": "default-bg-color"
        }
      ],
      //安全管理类指标
      aqKpis: [
        {
          "kpiCode": "SR-001",
          "kpiName": "安全/安保类自愿报告数量",
          "levelColor": null,
          "target": "-",
          "actual": "-",
          "colorClass": "default-bg-color"
        }, {
          "kpiCode": "SR-002",
          "kpiName": "强制报告上报率",
          "levelColor": null,
          "target": 1,
          "actual": "-",
          "colorClass": "default-bg-color"
        }, {
          "kpiCode": "SR-003",
          "kpiName": "外部信息",
          "levelColor": null,
          "target": 0.5,
          "actual": "-",
          "colorClass": "default-bg-color"
        }, {
          "kpiCode": "SR-005",
          "kpiName": "整改按期关闭率",
          "levelColor": null,
          "target": "-",
          "actual": "-",
          "colorClass": "default-bg-color"
        }, {
          "kpiCode": "SR-006",
          "kpiName": "审核监察计划执行率",
          "levelColor": null,
          "target": 4.6,
          "actual": "-",
          "colorClass": "default-bg-color"
        }, {
          "kpiCode": "SR-007",
          "kpiName": "安全培训完成率",
          "levelColor": null,
          "target": "-",
          "actual": "-",
          "colorClass": "default-bg-color"
        }, {
          "kpiCode": "SR-004",
          "kpiName": "法定自查条款完成率",
          "levelColor": null,
          "target": "-",
          "actual": "-",
          "colorClass": "default-bg-color"
        }, {
          "kpiCode": "SR-009",
          "kpiName": "舱音监察不合格率",
          "levelColor": null,
          "target": 1.2,
          "actual": "-",
          "colorClass": "default-bg-color"
        }, {
          "kpiCode": "SR-047",
          "kpiName": "安委会出席率",
          "levelColor": null,
          "target": 1.8,
          "actual": "-",
          "colorClass": "default-bg-color"
        }
      ],
      jcKpis: [],
      coreRisks: null,
      safeResult: {
        //日期组件
        dateConfig: {
          currentDateText: null,
          currentYear: null,
          currentMonth: null,
          onYearMonthChange: (date) => {
            this.safeResult.dateConfig.currentDateText = date.format("yyyy-MM");
            this.safeResult.dateConfig.currentYear = date.getFullYear();
            this.safeResult.dateConfig.currentMonth = date.getMonth() + 1;
            this.buildGhKpis();
          },
        },
      },
      coreRisk: {
        //当前页数据
        pageData: [],
        //全部数据
        all: [],
        pageNum: 1,
        hasNextPage: true,
        hasPreviousPage: true,
        //日期组件
        dateConfig: {
          currentDateText: null,
          currentYear: null,
          currentMonth: null,
          onYearMonthChange: (date) => {
            this.coreRisk.dateConfig.currentDateText = date.format("yyyy-MM");
            this.coreRisk.dateConfig.currentYear = date.getFullYear();
            this.coreRisk.dateConfig.currentMonth = date.getMonth() + 1;
            this.buildDhKpis();
            //切换时间后，回到第1页
            // this.coreRisk.pageNum = 1;
          },
        },
      },
      keyProcess: {
        //当前页数据
        pageData: [],
        //全部数据
        all: [],
        pageNum: 1,
        hasNextPage: true,
        hasPreviousPage: true,
        //日期组件
        dateConfig: {
          currentDateText: null,
          currentYear: null,
          currentMonth: null,
          onYearMonthChange: (date) => {
            this.keyProcess.dateConfig.currentDateText = date.format("yyyy-MM");
            this.keyProcess.dateConfig.currentYear = date.getFullYear();
            this.keyProcess.dateConfig.currentMonth = date.getMonth() + 1;
            this.buildAqKpis();
            //切换时间后，回到第1页
            // this.coreRisk.pageNum = 1;
          },
        },
      },
      //运行概况配置
      operationOverviewConfig: {
        //展示单元格
        viewCells: [{
          //包裹的kpi
          kpis: [{
            //当前月份值
            currentMonthValue: null
          }],
        }],
        //当前页数据
        pageData: [],
        //全部数据
        all: [],
        pageNum: 1,
        hasNextPage: true,
        hasPreviousPage: true,
        //日期组件
        dateConfig: {
          currentDateText: null,
          currentYear: null,
          currentMonth: null,
          onYearMonthChange: (date) => {
            this.operationOverviewConfig.dateConfig.currentDateText = date.format("yyyy-MM");
            this.operationOverviewConfig.dateConfig.currentYear = date.getFullYear();
            this.operationOverviewConfig.dateConfig.currentMonth = date.getMonth() + 1;
            this.buildJcKpis();
          },
        },
      },
    }
  },
  computed: {
    //注：取上个月的值
    currentMonth() {
      return this.operationOverviewConfig.dateConfig.currentMonth;
    },
  },
  mounted() {
    //触发构建重点监控指标和基础指标
    let now = new Date();
    this.safeResult.dateConfig.onYearMonthChange(now);
    this.coreRisk.dateConfig.onYearMonthChange(now);
    this.keyProcess.dateConfig.onYearMonthChange(now);
    this.operationOverviewConfig.dateConfig.onYearMonthChange(now);
  },
  methods: {
    buildGhKpis() {
      getRequest("/map/caac/board/gh", {
        year: this.safeResult.dateConfig.currentYear,
        month: this.safeResult.dateConfig.currentMonth,
      }, this.$refs.ghKpis)
        .then(res => {
          this.ghKpis = res.data
          this.ghKpis.forEach((item) => {
            item.colorClass = this.$util.getRiskLevelBgColor(item.levelColor);
            if (item.target == null) item.target = "-";
            if (item.actual == null) item.actual = "-";
          })
        })
    },
    /**
     * 前往旧安全地图
     */
    onSafeMapClick() {
      this.$router.push({name: "safeMapHu"})
    },
    /**
     * 核心风险：下一页
     */
    coreRiskNext() {
      if (this.coreRisk.hasNextPage) {
        this.buildCoreRiskByPage(++this.coreRisk.pageNum);
      }
    },
    /**
     * 核心风险：上一页
     */
    coreRiskPrev() {
      if (this.coreRisk.hasPreviousPage) {
        this.buildCoreRiskByPage(--this.coreRisk.pageNum);
      }
    },
    buildDhKpis() {
      getRequest("/map/caac/board/dh", {
        year: this.coreRisk.dateConfig.currentYear,
        month: this.coreRisk.dateConfig.currentMonth,
      }, this.$refs.dhKpis)
        .then(res => {
          this.dhKpis = res.data
          this.dhKpis.forEach((item) => {
            item.colorClass = this.$util.getRiskLevelBgColor(item.levelColor);
            if (item.target == null) item.target = "-";
            if (item.actual == null) item.actual = "-";
          })
        })
    },
    buildCoreRiskByPage(page = this.coreRisk.pageNum) {
      this.coreRisk.pageData = this.coreRisk.all[page - 1];
      this.coreRisk.hasPreviousPage = this.coreRisk.pageNum - 1 > 0;
      this.coreRisk.hasNextPage = this.coreRisk.pageNum < this.coreRisk.all.length
    },
    /**
     * 构建运行概况
     */
    buildOperationOverview() {
      postRequest("/dwKpiOs/safetyMapCaac/statistics", {
        year: this.operationOverviewConfig.dateConfig.currentYear,
      }, this.$refs.runningOverview).then(res => {
        this.operationOverviewConfig.viewCells = [{kpis: [], remain: 2}];

        res.data.forEach(kpiData => {
          this.appendViewCellForOS(kpiData);
        })
      })
    },
    /**
     * 往运行概况面板追加KPI，直到到达最大容量
     */
    appendViewCellForOS(kpiData) {
      //取最后一格
      let viewCellLength = this.operationOverviewConfig.viewCells.length;
      let viewCell = this.operationOverviewConfig.viewCells[viewCellLength - 1]
      //剩余容量
      let remain = viewCell.remain;
      let dimension = kpiData.dimension;
      //占用容量
      let occupied = !dimension || dimension === "NONE" ? 1 : 2;
      //是否区分维度
      let isDimension = dimension && dimension !== "NONE";
      let kpiName = kpiData.kpiName;
      //还有剩余容量，则添加，容量不够，则另起一格
      if (remain >= occupied) {
        let currentMonthValue;
        let lastMonthValue;
        //增量
        let monthValueIncrement;
        if (!dimension || dimension === "NONE") {
          if (!kpiData.actualValueList || !kpiData.actualValueList.length) {
            currentMonthValue = "该指标未配置";
          } else {
            kpiData.actualValueList.every(actual => {
              //取当前月的值
              if (this.currentMonth === actual.month) {
                currentMonthValue = actual.value;
                return false;
              }
              return true;
            })
            kpiData.actualValueList.every(actual => {
              //取上个月的值
              if (this.currentMonth - 1 === actual.month) {
                lastMonthValue = actual.value;
                return false;
              }
              return true;
            })
            if (currentMonthValue != null && lastMonthValue != null) {
              monthValueIncrement = this.$util.minus(currentMonthValue, lastMonthValue);
            }
          }
        } else {
          if (!kpiData.actualValueList || !kpiData.actualValueList.length) {
            currentMonthValue = [];
          } else {
            kpiData.actualValueList.forEach(actual => {
              //取当前月的值
              if (this.currentMonth === actual.month) {
                currentMonthValue = actual.dimensionValueList;
              }
            });
          }
        }
        let kpi = {
          kpiName,
          isDimension,
          currentMonthValue,
          lastMonthValue,
          monthValueIncrement,
        }
        viewCell.kpis.push(kpi);
        viewCell.remain = remain - occupied;
      } else {
        //超过极限数量，不再追加
        if (viewCellLength === 8) return;
        this.operationOverviewConfig.viewCells.push({kpis: [], remain: 2});
        this.appendViewCellForOS(kpiData);
      }
    },
    buildAqKpis() {
      getRequest("/map/caac/board/aq", {
        year: this.keyProcess.dateConfig.currentYear,
        month: this.keyProcess.dateConfig.currentMonth,
      }, this.$refs.aqKpis)
        .then(res => {
          this.aqKpis = res.data
          this.aqKpis.forEach((item) => {
            item.colorClass = this.$util.getRiskLevelBgColor(item.levelColor);
            if (item.target == null) item.target = "-";
            if (item.actual == null) item.actual = "-";
          })
        })
    },
    buildJcKpis() {
      getRequest("/map/caac/board/jc", {
        year: this.operationOverviewConfig.dateConfig.currentYear,
        month: this.operationOverviewConfig.dateConfig.currentMonth,
      }, this.$refs.jcKpis)
        .then(res => {
          this.jcKpis = res.data
          this.jcKpis.forEach((item) => {
            item.colorClass = this.$util.getRiskLevelBgColor(item.levelColor);
            if (item.target == null) item.target = "-";
            if (item.actual == null) item.actual = "-";
          })
        })
    },
    buildKeyProcessByPage(page = this.keyProcess.pageNum) {
      this.keyProcess.pageData = this.keyProcess.all[page - 1];
      this.keyProcess.hasPreviousPage = this.keyProcess.pageNum - 1 > 0;
      this.keyProcess.hasNextPage = this.keyProcess.pageNum < this.keyProcess.all.length
    },
    /**
     * 关键流程：下一页
     */
    keyProcessNext() {
      if (this.keyProcess.hasNextPage) {
        this.buildKeyProcessByPage(++this.keyProcess.pageNum);
      }
    },
    /**
     * 关键流程：上一页
     */
    keyProcessPrev() {
      if (this.keyProcess.hasPreviousPage) {
        this.buildKeyProcessByPage(--this.keyProcess.pageNum);
      }
    },
    /**
     * 跳转
     */
    toSafeResult(safeResult) {
      // let query = this.enableJumpToSafeResult(safeResult) ? {symptom: safeResult.kpiCode} : null;
      // this.$router.push({name: "safeResult", query: query});
    },
    toCoreRisk(code) {
      this.$router.push({name: "coreRisk", query: {code: code}});
    },
    toKeyProcess(code) {
      this.$router.push({name: "keyProcess", query: {code: code}});
    },
    /**
     * 是否支持跳转到安全结果页面
     */
    enableJumpToSafeResult(safeResult) {
      return safeResult.kpiCode !== 'SR-009' && safeResult.kpiCode !== 'SR-001'
    }
  },
  watch: {
    company() {
      this.buildGhKpis();
      this.buildDhKpis();
      this.buildOperationOverview();
      this.buildAqKpis();
      this.buildJcKpis();
    }
  }
}
</script>
<style scoped lang="less">
.content-business {
  width: 49.4%;

  &:nth-child(2n-1) {
    margin-right: auto;
  }
}

.sms-content-top {
  margin-bottom: 18px;
  display: flex;

  .content-business-main {
    padding-top: 35px;
    padding-bottom: 15px;
    //确保分页盒子固定在底部
    justify-content: space-between;
    box-sizing: border-box;
  }
}

.sms-content-bottom {
  display: flex;

  .content-business-main {
    padding-top: 15px;
    box-sizing: border-box;

    .operate {
      margin-bottom: 30px;
    }
  }

  .business-key-process,.business-running-overview {
    .content-business-main {
      padding-top: 15px;
      padding-bottom: 50px;
      //确保分页盒子固定在底部
      justify-content: space-between;
      box-sizing: border-box;
    }
  }
}

//业务容器公用样式
.content-business-main {
  display: flex;
  flex-direction: column;
  height: 370px;
  background-color: #fff;
  border-radius: 10px;

  .main-box {
    display: flex;
    flex-wrap: wrap;
    margin-left: 35px;

    .business-cell {
      width: (100%/3);
      display: flex;
      align-items: center;
      padding: 0 15px;
      box-sizing: border-box;

      .cell-left {
        width: 99%;

        .event-level {
          margin-bottom: 10px;

          .event-level-box {
            display: flex;
            align-items: center;

            .risk-color {
              width: 12px;
              height: 12px;
              border-radius: 50%;
            }

            .risk-detail {
              font-size: 16px;
              color: #ccc;
            }

            .risk-name {
              padding: 0 8px;
              font-weight: bold;
              font-size: 14px;
              max-width: 82%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }

        .part-bottom {
          display: flex;
          align-items: center;
          font-size: 12px;

          .index-name, .index-value {
            line-height: 20px;
          }

          .index-value {
            span {
              margin: 0 4px;
              font-weight: bold;
            }
          }
        }
      }

      .cell-right {
        width: 1%;
      }
    }
  }

  .operate {
    display: flex;
    height: 30px;
    justify-content: flex-end;

    .arrow-box {
      display: flex;
      align-items: center;

      .arrow-left, .arrow-right {
        height: 100%;
        display: flex;
        align-items: center;

        .light-icon {
          display: inherit;
        }

        .dark-icon {
          display: none;
        }

        &:hover {
          cursor: default;
        }

        &.enable {
          &:hover {
            cursor: pointer;

            .light-icon {
              display: none;
            }

            .dark-icon {
              display: inherit;
            }
          }
        }
      }

      .arrow-left {
        padding-left: 16px;
        padding-right: 6px;
      }

      .arrow-right {
        padding-left: 6px;
        padding-right: 16px;
      }
    }

    //日期选择器定制样式
    .el-date-picker-wrapper {
      width: 140px;

      /deep/ .el-date-editor {
        width: 100%;
      }

      /deep/ .el-input__inner {
        border: none;
        color: #409EFF;
        font-size: 22px;
        font-weight: bold;
      }

      /deep/ .el-input__icon {
        font-size: 22px;
        font-weight: bold;
      }
    }
  }
}

//安全结果、核心风险、关键流程特殊处理
.business-safe-result, .business-core-risk, .business-key-process {
  //除了前3个块，其余都要加上边距
  .business-cell:not(:nth-child(-n+3)) {
    margin-top: 25px;
  }

  //第3，6，9个块不需要加边框
  .business-cell:not(:nth-child(3n)) .cell-right {
    height: 60px;
    border-right: 1px solid #e7e7e7;
  }
}

//安全结果、核心风险特殊处理
.business-safe-result, .business-core-risk, .business-key-process {
  .business-cell {
    .cell-left {
      .event-level {
        .event-level-box {
          &:hover {
            color: #49d58d;
            cursor: pointer;
          }
        }
      }
    }
  }
}

.business-safe-result, .business-running-overview {
  .operate {
    justify-content: flex-start;
    padding-left: 30px;
  }
}

//运行概况
.business-running-overview {
  .content-business-main {
    .operate {
      margin-bottom: 20px;
    }

    .main-box {
      .business-cell {
        //提升z轴值，避免被中央大圆绝对定位挡住，导致无法点击
        z-index: 1;

        .cell-left {
          .event-level {
            margin-bottom: 7px;
          }
        }
      }
    }
  }

  //除了前3个块，其余都要加上边距
  .business-cell:not(:nth-child(-n+3)) {
    margin-top: 15px;
  }
}

//关键流程
.business-key-process {
  .content-business-main {
    .operate {
      margin-bottom: 20px;
    }

    .main-box {
      .business-cell {
        //提升z轴值，避免被中央大圆绝对定位挡住，导致无法点击
        z-index: 1;

        .cell-left {
          .event-level {
            margin-bottom: 7px;
          }
        }
      }
    }
  }

  //除了前3个块，其余都要加上边距
  .business-cell:not(:nth-child(-n+3)) {
    margin-top: 15px;
  }
}

//中间的大圆
.sms-content-center-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;

  .left, .right {
    height: 110px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .name {
      font-size: 16px;
      font-weight: bold;
      color: #3A404C;
      margin: 5px 10px;
    }
  }

  .sms-content-center {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 205px;
    height: 192px;
    background: url(../../assets/center_logo.jpg) no-repeat;
    background-size: 100%;


    .inner {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 110px;
      height: 110px;
      background-size: 100%;
      border-radius: 50%;
      background: #f0f1f6 url(../../assets/center_rotate.png) no-repeat;

      .name {
        text-align: center;
        font-size: 18px;
        font-weight: bold;
        color: #3A404C;
        margin: -2px 0;
      }
    }
  }
}

//右侧切换按钮
.sms-content-right-container {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(-50%, -50%);

  .light-icon {
    display: inherit;
  }

  .dark-icon {
    display: none;
  }

  &:hover {
    cursor: default;
  }

  &:hover {
    cursor: pointer;

    .light-icon {
      display: none;
    }

    .dark-icon {
      display: inherit;
    }
  }

  img {
    width: 30px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/achievement/SafeMapCaac.vue